import { Button, useMutation, useNotify, useRefresh } from "react-admin";

interface ISaveActionPassenger {
  action?: string;
  assignmentLocationId: number;
  assignmentPassengerId: number;
  assignmentId: number;
}

const SaveActionPassenger = ({
  action,
  assignmentLocationId,
  assignmentPassengerId,
  assignmentId,
}: ISaveActionPassenger) => {
  const notify = useNotify();
  const refresh = useRefresh();

  const [handleSaveActionPassenger, { loading }] = useMutation(
    {
      type: "customUpdate",
      resource: `assignments/${assignmentId}/locations/${assignmentLocationId}/passengers/${assignmentPassengerId}/${action}`,
      payload: {},
    },
    {
      onSuccess: ({ data }) => {
        notify(`Successfully change action passenger.`, "info");
        refresh();
      },
      onFailure: (error) =>
        notify(
          `Failed change action passenger, error: ${error.message}`,
          "warning"
        ),
    }
  );

  return (
    <Button
      onClick={handleSaveActionPassenger}
      color="primary"
      label={loading ? "Loading..." : `Save`}
      disabled={!action && true}
    />
  );
};

export default SaveActionPassenger;
